module.exports = __webpack_public_path__ + "media/images/user/lp/solution/medicine-6297a48eddd26c83af1918bb8c6a4975.png";